import React from 'react';
import { spriteForItem } from '../../utils/itemSprites';
import { staffItemImage } from '../../data/guide/itemImages';
import { EntityImage } from './EntityImage';

/**
 * Imagen de un ítem por ID exacto, con vista previa (cursor/teclado en computadora, toque en celular).
 * Prioridad: imagen individual del staff para ese ID → celda de la lámina → (variantes) "Imagen del ítem base".
 * La imagen nunca activa el enlace que la contiene. Sin imagen: nada en listados; marcador neutro con `placeholder`.
 */
export function ItemThumb({
  id,
  name,
  size = 'thumb',
  placeholder = false,
  focusable = true,
  lazy = true
}: {
  id?: string;
  name: string;
  size?: 'thumb' | 'card' | 'hero';
  placeholder?: boolean;
  focusable?: boolean;
  lazy?: boolean;
}) {
  const own = staffItemImage(id);
  if (own) return <EntityImage entry={{
    key: `item:${id}`,
    label: name,
    kind: 'monstruo',
    image: own
  }} alt={name} name={name} size={size} kind="item" focusable={focusable} lazy={lazy} data-id="element-1484" data-mp="1ihkl37itydge" />;
  const sprite = spriteForItem(id);
  if (!sprite && !placeholder) return null;
  const label = sprite?.isBase ? `${name} · Imagen del ítem base` : name;
  return <EntityImage sprite={sprite} alt={label} name={label} size={size} kind="item" focusable={focusable} lazy={lazy} data-id="element-1485" data-mp="3l8m7ay5pg1nt" />;
}